import "./Catalog.module.css";
import Header from "@/reusable_sections/Header";
import HeroProducts from "./sections/HeroProducts";
import ProductosDisponibles from "./sections/ProductosDisponibles";
import TicketsExperiencesGrid from "./sections/TicketsExperiencesGrid";
import Quoterequestwhatsapp from "./sections/Quoterequestwhatsapp";
import Specificationimagemanager from "./sections/Specificationimagemanager";
import Footer from "@/reusable_sections/Footer";
export default function CatalogPage() {
  return <div>
      <Header />
      <HeroProducts />
      <ProductosDisponibles />
      <TicketsExperiencesGrid />
      <Quoterequestwhatsapp />
      <Specificationimagemanager />
      <Footer />
    </div>;
}